module.exports = {"id":"215089","name":"Enzo Kalinski","rating":"73","photo":"./data/images/photos/3/215089.png","club":{"name":"Banfield","logo":"./data/images/clubs/Banfield.png"},"positions":["MC","MDC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/EnzoKalinski0.json
// module id = 1260
// module chunks = 0